import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";

class MobileMenu extends React.Component {

	constructor(props) {
		super(props);
		this.state = {isOpen: false }
		this.handleMenuButton = this.handleMenuButton.bind(this);
	}

	//	Update input form
	handleMenuButton(event) {
		this.setState({ isOpen: !this.state.isOpen });
	}

	renderMobileMenuOpened = () => {

		return(
			
			<nav id="nav">
				<div className="nav-wrap">
					<div className="nav-title-flex">
						<div className="nav-title">
							WISHCAMS MENU
						</div>
						<div id="menuButtonClose" onClick={this.handleMenuButton}>
							<FontAwesomeIcon icon={faTimes} />
						</div>
					</div>
					<div className="navLinks">
						<NavLink to="/" activeClassName="active" exact onClick={this.handleMenuButton}>Home</NavLink>
						<NavLink to="/tag/asian/" activeClassName="active" onClick={this.handleMenuButton}>Asian</NavLink>
						<NavLink to="/tag/ebony/" activeClassName="active" onClick={this.handleMenuButton}>Ebony</NavLink>
						<NavLink to="/tag/latina/" activeClassName="active" onClick={this.handleMenuButton}>Latina</NavLink>
						<NavLink to="/tag/white/" activeClassName="active" onClick={this.handleMenuButton}>White</NavLink>
						<NavLink to="/tag/teen/" activeClassName="active" onClick={this.handleMenuButton}>Teen</NavLink>
						<NavLink to="/tag/milf/" activeClassName="active" onClick={this.handleMenuButton}>MILF</NavLink>
						<NavLink to="/tag/mature/" activeClassName="active" onClick={this.handleMenuButton}>Mature</NavLink>
						<NavLink to="/tag/fetish/" activeClassName="active" onClick={this.handleMenuButton}>Fetish</NavLink>
						<NavLink to="/contact/" activeClassName="active" strict onClick={this.handleMenuButton}>Contact</NavLink>
					</div>
					<div className="menuFooter">
						<p>The site contains sexually explicit material not safe for work.</p>
						<p>This site is owned and operated by Wish Media</p>
						<p className="highlight">&copy; 2020 WishCams.com - All Rights Reserved</p>
					</div>
				</div>
			</nav>

		)

	}

	renderMobileMenuClosed = () => {

		return(
			<div id="menuButton" onClick={this.handleMenuButton}>
				<FontAwesomeIcon icon={faBars} />
			</div>
		)

	}
	
	render() {

		return (
			<div>
				{this.state.isOpen ?  this.renderMobileMenuOpened() : this.renderMobileMenuClosed()}
			</div>
		);
	}
}

export default MobileMenu;


// WEBPACK FOOTER //
// ./src/components/parts/MobileMenu.js